import React, { useCallback } from "react";
import { Col, Row } from "components/bootstrap";
import UserSearchFilterForm from "search-filter/components/filter-management-pages/UserSearchFilterForm";
import { Headline } from "components/common/Section/SectionComponent";
import useUserSearchFilterMutation from "search-filter/hooks/useUserSearchFilterMutation";
import CurrentUser from "logic/users/CurrentUser";
import useHistory from "routing/useHistory";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import SearchFiltersRoutes from "search-filter/Routes";
const UserSearchFilterCreate = () => {
  const { post } = useUserSearchFilterMutation();
  const history = useHistory();
  const sendTelemetry = useSendTelemetry("search-filter");
  const onSave = useCallback(
    (searchFilter) => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.SEARCH_FILTER_CREATED, {
        app_pathname: "my-filters"
      });
      return post({ data: searchFilter }).then(
        () => CurrentUser.reload().then(() => {
          history.push(SearchFiltersRoutes.LIST);
        })
      );
    },
    [history, post, sendTelemetry]
  );
  return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { xs: 12 }, /* @__PURE__ */ React.createElement(Headline, null, "Create Filter")), /* @__PURE__ */ React.createElement(Col, { xs: 12 }, /* @__PURE__ */ React.createElement(
    UserSearchFilterForm,
    {
      onSubmit: onSave,
      submitButtonText: "Create filter",
      submitLoadingText: "Creating filter..."
    }
  )));
};
export default UserSearchFilterCreate;
